export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10566.42a61bac.jpg";